export const HERO_SLIDES = [
  { img: "https://images.unsplash.com/photo-1710343491609-0cbc6c14b92d" },
  { img: "https://images.pexels.com/photos/8425027/pexels-photo-8425027.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400" },
  { img: "https://images.pexels.com/photos/18369298/pexels-photo-18369298.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400" },
  { img: "https://images.pexels.com/photos/15774577/pexels-photo-15774577.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400" },
];
